
import { defineComponent } from "vue";
import { store } from "@/store";
import Banner from "@/components/Banner.vue";

export default defineComponent({
  components: {
    Banner,
  },
  computed: {
    loggedIn: function () {
      return (
        store.getters.getJWT + store.getters["organisation/getOrganisationId"]
      );
    },
    lmsModules: function () {
      return store.getters["lmsCourse/getModules"];
    },
    userId: function (): string {
      return store.getters["getUserId"] ?? "anon";
    },
  },
  watch: {
    loggedIn: function () {
      this.init();
    },
  },
  methods: {
    lmsIsCompleted(moduleId: string): boolean {
      return store.getters["lmsCourse/isCompleted"](moduleId);
    },
    init: async function () {
      await store.dispatch("lmsCourse/LOAD_CATALOG");
      for (const m of this.lmsModules) {
        store.dispatch("lmsCourse/LOAD_PROGRESS", {
          userId: this.userId,
          moduleId: m.id,
        });
      }
    },
    points() {
      return [
        "Hier finden Sie alle für Sie freigegebenen Kurse.",
        "Klicken Sie einfach auf das zu bearbeitende Thema, um dieses zu starten.",
        "Sie können jedes Lernmodul jederzeit pausieren und zu einem späteren Zeitpunkt fortsetzen.",
        "Klicken Sie jetzt auf das gewünschte Thema.",
      ];
    },
  },
  async mounted() {
    this.init();
  },
});
